<template>
  <ReHeight @click.stop.self.prevent>
    <div ref="toolreheight"
    @dblclick.stop.prevent="heightAuto" style="
      width: 100%;
      height: 100%;
      text-align: center;
      color: #ffffff;
    ">
      <span>
        <i class="far fa-arrows-alt-v"></i>
      </span>
      <ToolLabel v-if="mode == reheight_mode" class="px-2 mx-2" style="">
        W: {{ displayWidth }}, H: {{ height }}
      </ToolLabel>
    </div>
  </ReHeight>
</template>

<script>
import { mapGetters } from "vuex";
import { ReHeight, ToolLabel } from "./Reheight.styled";
export default {
  components: {
    ReHeight,
    ToolLabel,
  },
  data() {
    return {
      reheight_mode: "reheight_grid",
      height: 0,
      width: 0,
      cellRatio: [],
    };
  },
  computed: {
    ...mapGetters({
      components: "designIframe/metadata/components",
      sectionActive: "designIframe/frame/sectionActive",
      gridActive: "designIframe/frame/gridActive",
      gridHover: "designIframe/frame/gridHover",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
    }),
    styleDevice() {
      switch (this.detectDevice) {
        case "mobile":
          return "styleMobile";
        case "tablet":
          return "styleTablet";
        default:
          return "style";
      }
    },
    component() {
      return this.components[this.component_id];
    },

    componentLayout() {
      return this.component.style.layout;
    },
    sectionComponent() {
      return this.sectionActive && this.sectionActive.id && this.components[this.sectionActive.id]
    },
    displayWidth() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' ? 'auto' : this.width;
    }
  },
  watch: {},
  props: ["component_id"],
  mounted() {
    this.dragElement();
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    repositionGridFrame() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.gridActive.id,
        type: "GRID",
        action: "ACTIVE",
      });
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.gridHover.id,
        type: "GRID",
        action: "HOVER",
      });
    },
    repositionSectionFrame() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.sectionActive.id,
        type: "SECTION",
        action: "ACTIVE",
      });
    },
    dragElement() {
      this.$refs["toolreheight"].onmousedown = this.dragMouseDown;
    },
    dragMouseDown(e) {
      console.log("resize mode");
      e = e || window.event;
      this.$store.dispatch("design/setMode", {
        mode: this.reheight_mode,
      });
      e.preventDefault();
      this.initCellRatio();
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      document.onmousemove = this.elementDrag;
    },
    initCellRatio() {
      const element = document.getElementById(`comp-${this.component_id}`);
      this.height = element.offsetHeight;
      this.width = element.offsetWidth;
      const config = this.component.componentsID.map((child_id) => {
        const child = document.getElementById(`comp-${child_id}`);
        return {
          id: child_id,
          height: child.offsetHeight + this.component.style.cellGap,
        };
      });
      const max = Math.max(
        ...[
          ...config.map((i) => i.height),
          element.offsetHeight + this.component.style.cellGap,
        ]
      );
      this.cellRatio = config.map((i) => ({ ...i, ratio: i.height / max }));
    },
    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;

      const element = document.getElementById(`comp-${this.component_id}`);
      this.height = element.offsetHeight;
      this.cellRatio.forEach((item) => {
        const child = document.getElementById(`comp-${item.id}`);
        const newHeight =
          child.offsetHeight +
          (this.$refs["toolreheight"].offsetTop - this.pos2) * item.ratio;
        this.components[item.id][this.styleDevice].height =
          Math.ceil(newHeight) > 30 ? Math.ceil(newHeight) : 30;
      });
      this.repositionGridFrame();
      this.repositionSectionFrame();
    },

    closeDragElement() {
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      this.$store.dispatch("design/setMode", {});
      document.onmouseup = null;
      document.onmousemove = null;
    },
    heightAuto() {
      this.cellRatio.forEach((item) => {
        this.components[item.id][this.styleDevice].height = 'auto';
      });
      this.$nextTick(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
      });
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        if(this.mode == this.reheight_mode) this.closeDragElement();
      }
    },
  },
};
</script>

<style>
</style>